import { render, staticRenderFns } from "./global-messages.vue?vue&type=template&id=e867d712&"
import script from "./global-messages.vue?vue&type=script&lang=ts&"
export * from "./global-messages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports